export const themeColors = {
   backgroundColor:"#fffafa",
   backgroundColorDark:"#002029",
   thBackgroundColor:"#e9ecef",
   thBackgroundColorDark:"#004052",
   tdBackgroundColor:"#f8f9fa",
   tdBackgroundColorDark:"#1a2b3c",
   textPrimary:"#000",
   textPrimaryDark:"#fff",
   buttonPrimary:"#fff",
   buttonPrimaryDark:"#fff",
   cardBackgroundColor:"#fff",
   cardBackgroundColorDark:"#1a2b3c",
   dropdownBackgroundColor:"#fff",
   dropdownBackgroundColorDark:"#00303D",
   navbarBackgroundColor:"#fffafa",
   navbarBackgroundColorDark:"#00303D",
   sidebarBackgroundColor:"#fffafa",
   sidebarBackgroundColorDark:"#00303D",
   danger:"red",
   iconColor:"#000",
   iconColorDark:"#fff",
   iconColorAlternate:"#000",
   iconColorAlternateDark:"#fff",
   trBorderColor:"#e9ecef",
   trBorderColorDark:"#035268",
   thResourcesBackgroundColorDark:"#279ea0",
   thResourcesBackgroundColor:"#279ea0",
   primary:"#279ea0"
}

export const marginTop={
   sm:'5px'
}